/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import actionTypes from './Payment-ActionTypes';

const updateCompletedPaymentDetails = (data) => ({
    type: actionTypes.UPDATE_COMPLETE_PAYMENT_DETAILS,
    data,
});

const activePaymentMethod = (paymentMethod) => ({
    type: actionTypes.ACTIVE_PAYMENT_METHOD,
    data: {
        paymentMethod,
    },
});

const inActivePaymentMethod = (paymentMethod) => ({
    type: actionTypes.INACTIVE_PAYMENT_METHOD,
    data: {
        paymentMethod,
    },
});

const placeOrder = (config) => ({
    type: actionTypes.PLACE_ORDER,
    payload: config,
});

const placeOrderComplete = (payload) => ({
    type: actionTypes.PLACE_ORDER_COMPLETE,
    payload,
});

const applyGiftCardProccessCompleted = () => ({
    type: actionTypes.APPLY_GIFT_CARD_PROCESS_COMPLETED,
});

const loadPaymentMethods = (data) => ({
    type: actionTypes.CHECKOUT_PAYMENT_METHODS_LOAD,
    data,
});

export const updateShowOrderConfirmation = () => ({
    type: actionTypes.SHOW_ORDER_CONFIRMATION,
});

const postOrderCompleteAttributionData = (payload) => ({
    type: actionTypes.POST_ORDER_COMPLETE_ATTRIBUTION_DATA,
    payload,
});

// dependency

export const clearPassportError = () => ({
    type: 'PASSPORT/CLEAR_PASSPORT_ERROR',
});

export {
    placeOrder,
    placeOrderComplete,
    updateCompletedPaymentDetails,
    activePaymentMethod,
    inActivePaymentMethod,
    applyGiftCardProccessCompleted,
    loadPaymentMethods,
    postOrderCompleteAttributionData,
};
